"use client";

import { useEffect } from "react";

/**
 * Keeps `<html lang>` in step with the active locale.
 *
 * The attribute is server-rendered by the root layout, which is what makes it
 * correct in the first byte — but that layout sits above the `[locale]` segment
 * and so is never re-rendered when the reader switches language client-side. Left
 * alone, the document would go on declaring the language it was loaded in, which
 * is what a screen reader announces in and what `:lang()` styling keys off.
 *
 * Mounted from the [locale] layout, so it re-runs on exactly the navigations the
 * root layout misses.
 */
export function HtmlLang({ locale }: { locale: string }) {
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return null;
}
